module.exports = __webpack_public_path__ + "img/navbar-b.a9f270db.webp";